/**
 * @since 2023-08-07
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import TableWithPagination from "components/Shared/TableWithPagination";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { parseNumber } from "utils/parsing";

const ItemTableTrades = ({ itemData }) => {
  const intl = useIntl();

  const [dataTable, setDataTable] = useState(null);
  const columns = [
    {
      title: "Date/Time",
      dataIndex: "datetime",
      key: "datetime",
      tooltip: intl.formatMessage({
        id: "trades-datetime",
      }),
      sorter: (a, b) => new Date(a.datetime) - new Date(b.datetime),
      showSorterTooltip: false,
    },
    {
      title: "Instrument",
      dataIndex: "instrument",
      key: "instrument",
      tooltip: intl.formatMessage({
        id: "trades-instrument",
      }),
      sorter: (a, b) => a.instrument.localeCompare(b.instrument),
      showSorterTooltip: false,
    },
    {
      title: "Ticker",
      dataIndex: "ticker",
      key: "ticker",
      tooltip: intl.formatMessage({
        id: "live-trades-instrument",
      }),
      sorter: (a, b) => a.ticker.localeCompare(b.ticker),
      showSorterTooltip: false,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      tooltip: intl.formatMessage({
        id: "trades-category",
      }),
      sorter: (a, b) => a.category.localeCompare(b.category),
      showSorterTooltip: false,
    },
    {
      title: "Traded",
      dataIndex: "traded",
      key: "traded",
      className: "right-aligned-cell",
      tooltip: intl.formatMessage({
        id: "trades-traded",
      }),
      sorter: (a, b) => parseNumber(a.traded) - parseNumber(b.traded),
      showSorterTooltip: false,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      className: "right-aligned-cell",
      tooltip: intl.formatMessage({
        id: "trades-price",
      }),
      sorter: (a, b) => parseNumber(a.price) - parseNumber(b.price),
      showSorterTooltip: false,
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      className: "right-aligned-cell",
      tooltip: intl.formatMessage({
        id: "trades-newposition",
      }),
      sorter: (a, b) => parseNumber(a.position) - parseNumber(b.position),
      showSorterTooltip: false,
    },
  ];

  //region Use Effects

  useEffect(() => {
    (async () => {
      if (itemData === null) return;
      setDataTable(convertToAntDTableData(itemData));
    })();
  }, [itemData]);

  //endregion

  //region Methods

  function convertToAntDTableData(data) {
    return data.map((item, index) => ({
      key: index,
      datetime: item.DateTime,
      instrument: item.Instrument,
      ticker: item.Ticker,
      category: item.Category,
      traded: item.Traded,
      price: item.Price,
      position: item.Position,
    }));
  }

  //endregion

  return <TableWithPagination dataTable={dataTable} columns={columns} />;
};
export default ItemTableTrades;
